import { render, staticRenderFns } from "./Knowledgechart.vue?vue&type=template&id=606e1168&"
import script from "./Knowledgechart.vue?vue&type=script&lang=js&"
export * from "./Knowledgechart.vue?vue&type=script&lang=js&"
import style0 from "./Knowledgechart.vue?vue&type=style&index=0&id=606e1168&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports